import { LOGOUT_USER } from './types';

export const LogoutAction = () => {
  localStorage.clear()
  // document.cookie = "mycookie=1; expires=Thu, 01 Jan 1970 00:00:00 UTC"
  window.history.pushState("", "", '/');
  return {
    type: LOGOUT_USER,
    payload: false
  }
};
